export const GET_TEMPLATE_BY_SESSION_ID = "getTemplateBySessionId";
export const SET_END_SESSION = "setEndSession";
